import { createContext } from "react";
import { WidgetContext } from "..";

export const WidgetReactContext = createContext<WidgetContext>(undefined);
